<mat-sidenav-container>

    <mat-sidenav #sidenav>
      <ng-container *ngIf="isSpa">
        <app-side-nav (closeSideNav)="sidenav.close()"></app-side-nav>
      </ng-container>
    </mat-sidenav>
 

  <mat-sidenav-content>
    <ng-container *ngIf="isSpa">
      <app-toolbar (SideNavToggle)="sidenav.toggle()"></app-toolbar>
    </ng-container>

    <main>
      <router-outlet></router-outlet>
    </main>
    
  </mat-sidenav-content>
</mat-sidenav-container>